import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc2001',
    ecrans: ['00-2'],
    params: ['id']
});
